import React from 'react';
import { MicrosoftFileTriggerNode } from '../microsoftFileTrigger';
export function OneDriveTrigger(props: any) { return <MicrosoftFileTriggerNode {...props} provider="onedrive"/>; }
